/**
 * 抄表用水记录（meterUserRecordList）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/meterUserRecordList/ 下列表页（第 1 组：AccountClosureRecordsList ~ MeterUserinfoTransferRecordList）
 * 术语约定：日结=Daily Statement，月结=Monthly Statement，年报=Annual Report，发票=Invoice，
 *          缴费记录=Payment Records，流水=Transaction Record，抄表记录=Meter Reading Records，
 *          用水户=Customer，户号=Customer No.，户名=Customer Name，上期=Previous Period，本期=Current Period
 * 通用词（确定/取消/查询/重置/编辑/删除/详情/更多/批量操作/清空/操作/创建时间/创建人 等）见 en-US.js，此处不重复
 */
export default {
  // 区域树 / 通用操作
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '请输入区域名称': 'Please enter area name',
  '折叠': 'Collapse',
  '收起': 'Collapse',
  '展开': 'Expand',
  '刷新': 'Refresh',
  '导出': 'Export',
  '导入': 'Import',
  '自定义列': 'Custom Columns',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '未知': 'Unknown',
  '元': 'CNY',
  '条': ' records',
  '共{total}条': 'Total {total} records',
  '导出文件': 'Export File',
  '文件下载失败': 'File download failed',
  '请设置url.list属性!': 'Please set the url.list property!',
  // 查询条件
  '表编号': 'Meter No.',
  '表编号模糊查询': 'Search by meter no.',
  '请输入表编号': 'Please enter meter No.',
  '用户编号': 'Customer No.',
  '用户编号模糊查询': 'Search by customer no.',
  '请输入用户编号': 'Please enter customer No.',
  '用户姓名': 'Customer Name',
  '用户姓名模糊查询': 'Search by customer name',
  '请输入用户姓名': 'Please enter customer name',
  '用户地址': 'Customer Address',
  '用户地址模糊查询': 'Search by customer address',
  '请输入用户地址': 'Please enter customer address',
  '用户手机号': 'Customer Mobile Phone',
  '请输入用户手机号': 'Please enter customer mobile phone',
  '用户电话': 'Customer Phone',
  '新表编号': 'New Meter No.',
  '新表编号模糊查询': 'Search by new meter no.',
  '旧表编号': 'Old Meter No.',
  '旧表编号模糊查询': 'Search by old meter no.',
  '换表原因类型': 'Meter Replacement Reason Type',
  '请选择换表原因类型': 'Please select meter replacement reason type',
  '查询起止时间': 'Query Time Range',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '查询起始日期': 'Start date',
  '查询结束日期': 'End date',
  '起始时间': 'Start Time',
  '结束时间': 'End Time',
  '起止时间': 'Time Range',
  '销户时间': 'Account Closure Time',
  '查询日期': 'Query Date',
  '请选择查询日期': 'Please select query date',
  '请选择年': 'Please select year',
  '日期': 'Date',
  '价格名称': 'Price Name',
  '请选择价格名称': 'Please select price name',
  '新价格名称': 'New Price Name',
  '请选择新价格名称': 'Please select new price name',
  '旧价格名称': 'Old Price Name',
  '请选择旧价格名称': 'Please select old price name',
  '新价格启用时间': 'New Price Effective Time',
  '变更方式': 'Change Method',
  '请选择变更方式': 'Please select change method',
  '变更状态': 'Change Status',
  '请选择变更状态': 'Please select change status',
  '操作员': 'Operator',
  '请选择操作员': 'Please select operator',
  '操作类型': 'Operation Type',
  '请选择操作类型': 'Please select operation type',
  '缴费途径': 'Payment Channel',
  '请选择缴费途径': 'Please select payment channel',
  '交易流水号': 'Transaction Serial No.',
  '请输入交易流水号': 'Please enter transaction serial No.',
  '开票状态': 'Invoicing Status',
  '请选择开票状态': 'Please select invoicing status',
  '发票代码': 'Invoice Code',
  '请输入发票代码': 'Please enter invoice code',
  '表口径': 'Meter Caliber',
  '请选择表口径': 'Please select meter caliber',
  '统计层级': 'Statistics Level',
  '请选择统计层级': 'Please select statistics level',
  '一级区域': 'Level-1 Area',
  '二级区域': 'Level-2 Area',
  '三级区域': 'Level-3 Area',
  '用水量范围': 'Water Usage Range',
  // 报表 / 导出文件名
  '销户记录': 'Account Closure Records',
  '换表记录': 'Meter Replacement Records',
  '年报表': 'Annual Report',
  '售水统计报表': 'Water Sales Statistics Report',
  '日报表': 'Daily Statement',
  '月报表': 'Monthly Statement',
  '开票记录': 'Invoice Records',
  '缴费记录': 'Payment Records',
  '用水量查询': 'Water Usage Query',
  '区域用量报表': 'Area Usage Report',
  '日用量报表': 'Daily Usage Report',
  '月用量报表': 'Monthly Usage Report',
  '调价记录': 'Price Adjustment Records',
  '调价详情列表': 'Price Adjustment Details',
  '调价任务列表': 'Price Adjustment Tasks',
  '过户记录': 'Ownership Transfer Records',
  '批量调价': 'Batch Price Adjustment',
  // 消息提示
  '结束时间不能小于开始时间': 'End time cannot be earlier than start time',
  '查询起止时间跨度不能超过1天': 'The query time range cannot exceed 1 day',
  '查询起止时间跨度不能超过30天': 'The query time range cannot exceed 30 days',
  '查询起止时间跨度不能超过5天': 'The query time range cannot exceed 5 days',
  '用水量起始值不能大于终止值': 'Water usage start value cannot be greater than end value',
  '确定撤销开票吗?': 'Are you sure to revoke this invoice?',
  '已开票': 'Invoiced',
  '撤销开票': 'Revoke Invoice',
  '打印票据': 'Print Receipt',
  // 表格列（销户/换表/缴费/开票/过户/调价等）
  '表类型': 'Meter Type',
  '价格信息': 'Price Info',
  '操作人': 'Operated By',
  '操作时间': 'Operation Time',
  '创建日期': 'Created Date',
  '创建操作员代码': 'Creator Operator Code',
  '修改时间': 'Modified At',
  '修改操作员Id': 'Updated By Operator Id',
  '用户keyId  对应用户meter_userinfo表的id': 'Customer keyId (id of the meter_userinfo table)',
  '报表日期': 'Report Date',
  '上报所属月份 六位整数 高四位代表年份 低二位代表月份 格式如202010 ': 'Report month (6-digit integer, top 4 digits = year, last 2 digits = month, e.g. 202010) ',
  '日冻结用量': 'Daily Frozen Usage',
  '记录一天用各个时间点的吨数': 'Hourly usage volume (tons) of the day',
  '当天上报数据原始二进制字符串': 'Raw binary string of reported data of the day',
  '当天上报数据扩展解析字符串': 'Extended parsed string of reported data of the day',
  '上期时间 主要针对异常情况或者机械表': 'Previous Period time (mainly for abnormal cases or mechanical meters)',
  '上期水表累计流量': 'Previous Period Cumulative Meter Flow',
  '本期抄表时间': 'Current Period Meter Reading Time',
  '本期水表累计流量': 'Current Period Cumulative Meter Flow',
  '旧表结算流量(m³)': 'Old Meter Settlement Flow (m³)',
  '新表起始读数(m³)': 'New Meter Initial Reading (m³)',
  '旧表机械读数(m³)': 'Old Meter Mechanical Reading (m³)',
  '换表原因': 'Meter Replacement Reason',
  '换表结算余额(元)': 'Balance After Replacement Settlement (CNY)',
  '日用量(m³)': 'Daily Usage (m³)',
  '用量(m³)': 'Usage (m³)',
  '用水量(m³)': 'Water Consumption (m³)',
  '上报月份': 'Report Month',
  '区域名称': 'Area Name',
  '区域用量(m³)': 'Area Usage (m³)',
  '区域用量统计': 'Area Usage Statistics',
  '记录条数': 'Record Count',
  '年份': 'Year',
  '充值金额(元)': 'Recharge Amount (CNY)',
  '退费金额(元)': 'Refund Amount (CNY)',
  '营收金额(元)': 'Revenue Amount (CNY)',
  '总价(元)': 'Total Price (CNY)',
  '售水吨数(m³)': 'Water Sold (m³)',
  '净水费(元)': 'Basic Water Fee (CNY)',
  '水资源税(元)': 'Water Resource Tax (CNY)',
  '排污费(元)': 'Sewage Fee (CNY)',
  '收费金额(元)': 'Charge Amount (CNY)',
  '营业厅现金(元)': 'Cash at Business Hall (CNY)',
  '微信支付(元)': 'WeChat Pay (CNY)',
  '微信手续费(元)': 'WeChat Handling Fee (CNY)',
  '微信实到账(元)': 'WeChat Amount Received (CNY)',
  '扫码支付(元)': 'QR Code Payment (CNY)',
  '对公转账(元)': 'Corporate Bank Transfer (CNY)',
  '购买金额(元)': 'Purchase Amount (CNY)',
  '购买量(吨)': 'Purchase Volume (t)',
  '缴费时间': 'Payment Time',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '开票时间': 'Invoicing Time',
  '开票人': 'Invoicer',
  '新价格信息': 'New Price Info',
  '旧价格信息': 'Old Price Info',
  '新价格启用日期': 'New Price Effective Date',
  '新用户姓名': 'New Customer Name',
  '原用户姓名': 'Original Customer Name',
  '新用户手机号': 'New Customer Mobile Phone',
  '原用户手机号': 'Original Customer Mobile Phone',
  '新身份证号': 'New ID Number',
  '原身份证号': 'Original ID Number',
  '原价格信息': 'Original Price Info',
  '使用总量': 'Total Usage',
  '累计充值金额': 'Total Recharge Amount',
  '累计退水金额': 'Total Refund Amount',
  '累计补水金额': 'Total Water Supplement Amount',
  // 汇总卡片（日/月/年报表 totalList）
  '充值金额': 'Recharge Amount',
  '退费金额': 'Refund Amount',
  '营收金额': 'Revenue Amount',
  '收费总金额': 'Total Charge Amount',
  '微信实收金额': 'WeChat Amount Received',
  '微信手续费': 'WeChat Handling Fee',
  '对公转账': 'Corporate Bank Transfer',
  '营业厅现金': 'Cash at Business Hall',
  '扫码支付': 'QR Code Payment',
  '微信支付': 'WeChat Pay',
  '净水费总金额': 'Total Basic Water Fee',
  '水资源税总金额': 'Total Water Resource Tax',
  '排污费总金额': 'Total Sewage Fee',
  '售水吨数': 'Water Sold',
  'm³': 'm³',
  // 换表原因（级联选项 & 字典映射）
  '周期性换表': 'Periodic Meter Replacement',
  '故障换表': 'Faulty Meter Replacement',
  '基表问题': 'Base Meter Problem',
  '计量问题': 'Metering Problem',
  '阀门故障': 'Valve Fault',
  '基表爆裂': 'Base Meter Burst',
  '电子问题': 'Electronic Problem',
  '不上传数据': 'No Data Upload',
  '水表无反应（黑屏，无法激活）': 'Water meter unresponsive (black screen, cannot activate)',
  '磁干扰': 'Magnetic Interference',
  '缺电': 'Power Shortage',
  '故障换表/基表问题': 'Faulty Meter Replacement/Base Meter Problem',
  '故障换表/基表问题/计量问题': 'Faulty Meter Replacement/Base Meter Problem/Metering Problem',
  '故障换表/基表问题/阀门故障': 'Faulty Meter Replacement/Base Meter Problem/Valve Fault',
  '故障换表/基表问题/基表爆裂': 'Faulty Meter Replacement/Base Meter Problem/Base Meter Burst',
  '故障换表/电子问题': 'Faulty Meter Replacement/Electronic Problem',
  '故障换表/电子问题/不上传数据': 'Faulty Meter Replacement/Electronic Problem/No Data Upload',
  '故障换表/电子问题/水表无反应(黑屏、无法激活)': 'Faulty Meter Replacement/Electronic Problem/Meter Unresponsive (black screen, cannot activate)',
  '故障换表/磁干扰': 'Faulty Meter Replacement/Magnetic Interference',
  '故障换表/缺电': 'Faulty Meter Replacement/Power Shortage',
  '故障换表/其他': 'Faulty Meter Replacement/Other',
  // 选项值映射（缴费操作类型 / 缴费途径 / 开票状态 / 变更方式 / 变更状态）
  '充值': 'Recharge',
  '退费': 'Refund',
  '补水': 'Water Supplement',
  '撤销充值': 'Revoke Recharge',
  '撤销退费': 'Revoke Refund',
  '撤销补水': 'Revoke Water Supplement',
  '未开票': 'Not Invoiced',
  '立即结算': 'Settle Immediately',
  '扣完再启用新价格': 'Enable New Price After Deduction',
  '待变更': 'Pending Change',
  '变更中': 'In Progress',
  '变更成功': 'Change Successful'
}
